import searchMatch from '../../../utils/searchMatch';
import { stripStopSuffix } from '../../../utils/composeDriverRecords';
import { getRouteShift } from './mapGeometry';

// Pure filter helpers for the Monitoring tab's shared filter bar. Kept free
// of React so MonitoringTab can memoize them and tests need no harness.

// True when the query matches the route itself (route name or any of its
// drivers) or any stop on it (location id — route-occurrence suffix
// stripped — or display name). Blank query = match.
export function routeMatchesQuery(driver, query) {
  if (!query || !query.trim()) {
    return true;
  }
  const routeText = `${driver.routeName || ''} ${(
    driver.driverNames || []
  ).join(' ')}`;
  if (searchMatch(routeText, query)) {
    return true;
  }
  return (driver.routeStops || []).some((stop) =>
    searchMatch(
      `${stripStopSuffix(stop.stopId) || ''} ${stop.stopName || ''}`,
      query,
    ),
  );
}

// 'all' passes every route; 'am' / 'pm' require that token in the route name.
export function matchesShift(driver, shiftFilter) {
  if (!shiftFilter || shiftFilter === 'all') {
    return true;
  }
  return getRouteShift(driver.routeName || driver.routeId) === shiftFilter;
}

// Shift + location narrow the fleet the pickers list from.
export function scopeDrivers(drivers, { shiftFilter, locationQuery }) {
  return drivers.filter(
    (driver) =>
      matchesShift(driver, shiftFilter) &&
      routeMatchesQuery(driver, locationQuery),
  );
}

// The driver focus narrows further for the views; the pickers keep the
// scoped list so a supervisor can switch drivers without clearing first.
// `selectedDriverEmail` is matched against each route's credited roster, so
// focusing someone keeps every route they actually worked — not just the one
// their latest ping happened to be stamped with.
export function focusDriver(drivers, selectedDriverEmail) {
  if (!selectedDriverEmail) {
    return drivers;
  }
  const email = selectedDriverEmail.toLowerCase();
  return drivers.filter((driver) =>
    (driver.driverRoster || []).some((entry) => entry.email === email),
  );
}

// Immutable toggle for the legend filter Sets: returns a new Set with
// `value` added or removed, so React state setters see a fresh reference.
export function toggleSetValue(currentSet, value) {
  const next = new Set(currentSet);
  if (next.has(value)) {
    next.delete(value);
  } else {
    next.add(value);
  }
  return next;
}
